import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { ReactivationPlanToSubmit } from '@/modules/employer/components/EmployerReactivation/types';

interface EmployerReactivationPayload {
  payroll_contribution_account_id: number;
  funding_replenishment_account_id: number;
  is_re_card_needed: boolean;
  plans_to_reactivate: ReactivationPlanToSubmit[];
}

export const useReactivateEmployerQuery = (id: string) => {
  const { mutateAsync, isPending, isSuccess } = useMutation((data: EmployerReactivationPayload) =>
    api.post(API_URL.ORGANIZATIONS_REACTIVATION_BY_ORGANIZATION_ID(id), data)
  );

  return {
    reactivateEmployer: mutateAsync,
    isLoading: isPending,
    isSuccess,
  };
};
